module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[28]149.c2b80bd.woff2";